import React, { useState } from "react";
import { Col, DatePicker, Modal, Row } from "antd";
import { useTranslation } from "react-i18next";
import "../../../../assets/style/modalStyle/postNews.scss";
import { useDispatch, useSelector } from "react-redux";
import LabelInput from "../../LabelInput";
import moment from "moment";
import {
  editBanner,
  setOpenModalEditBanner,
} from "../../../../services/slice/BannerSlice";
import UpImageEdit from "../../Button/UpImageEdit";
import { bannerSelector } from "../../../../services/selector/index.";
import { validateUrl } from "../../../../utils/functionCommon";
import BaseButton from "../../Button/BaseButton";
import InputText from "../../Input/InputText";

const ModalEditBanner = ({ title }) => {
  const bannerState = useSelector(bannerSelector);
  const { isOpenModalEditBanner, valueEdit } = bannerState;
  const [datapost, setDataPost] = useState({
    name: valueEdit.name,
    url: valueEdit.link,
    timeStart: valueEdit.timeStart,
    timeEnd: valueEdit.timeEnd,
    imageBanner: valueEdit.imageBanner,
  });
  const [image, setImage] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [error, setError] = useState({
    isError: false,
    msg: "",
  });
  const handleSave = () => {
    const firstTime = new Date(datapost.timeStart).getTime();
    const secondTime = new Date(datapost.timeEnd).getTime();

    if (
      !datapost.name ||
      !datapost.url ||
      !datapost.timeStart ||
      !datapost.timeEnd
      // !image
    ) {
      setError({
        isError: true,
        msg: "Vui lòng nhập đầy đủ thông tin",
      });
      return;
    }
    if (!validateUrl(datapost.url)) {
      setError({
        isError: true,
        msg: "Đường dẫn không hợp lệ",
      });
      return;
    }
    if (secondTime - firstTime <= 0) {
      setError({
        isError: true,
        msg: "Thời gian bắt đầu phải nhỏ hơn Thời gian kết thúc",
      });
      return;
    }

    if (image.size > 2 * 1024 * 1024) {
      setError({
        isError: true,
        msg: "Dung lượng ảnh phải nhỏ hơn < 2MB",
      });
      return;
    }
    // if (
    //   datapost.fileImage &&
    //   !allowedFormats.includes(datapost.fileImage.type)
    // ) {
    //   setError({
    //     isError: true,
    //     msg: "File có định dạng .jpeg, .png, .gif",
    //   });
    //   return;
    // }
    // const img = new Image();
    // img.onload = () => {
    //   const width = img.width;
    //   const height = img.height;
    //   console.log(width, height);
    //   // Kiểm tra kích thước ảnh
    //   if (!width && !height) {
    //     setError({
    //       isError: true,
    //       msg: "Kích thước ảnh không hợp lệ",
    //     });
    //     return;
    //   } else {
    //     console.log("ok");
    setError({
      isError: false,
      msg: "",
    });
    const formPost = new FormData();
    formPost.append("id", valueEdit.key);
    if (datapost.fileImage) {
      formPost.append("file", datapost.fileImage);
    }
    formPost.append("name", datapost.name);
    formPost.append(
      "timeStart",
      moment(datapost.timeStart).format("YYYY-MM-DD HH:mm:ss")
    );
    formPost.append(
      "timeEnd",
      moment(datapost.timeEnd).format("YYYY-MM-DD HH:mm:ss")
    );
    formPost.append("url", datapost.url);
    dispatch(editBanner(formPost));
  };

  const handleCancel = () => {
    dispatch(setOpenModalEditBanner(false));
  };
  const dateFormat = "YYYY-MM-DD HH:mm:ss";
  return (
    <>
      <Modal
        maskClosable={false}
        // className="wrapperModalEditBanner"
        title={t(title)}
        centered
        width={960}
        open={isOpenModalEditBanner}
        onCancel={handleCancel}
        footer={[
          <BaseButton
            content={"Hủy bỏ"}
            typeBtn="mainBtn btnCancel"
            width={120}
            handleClick={handleCancel}
          />,
          <BaseButton
            width={120}
            content={"Lưu"}
            typeBtn="btnOrange"
            // icon={<IconUpLoad />}
            handleClick={handleSave}
          />,
        ]}
      >
        <Row>
          <Col span={12}>
            <Row align={"middle"}>
              <Col span={8}>
                <LabelInput text={"Tên banner"} />
              </Col>
              <Col span={16}>
                <InputText
                  focus
                  text={datapost.name}
                  setText={(value) => setDataPost({ ...datapost, name: value })}
                  placeholder={"Nhập tên banner"}
                  typeInput={`${
                    !datapost.name && error.isError
                      ? "checkEmptyText baseInput"
                      : "baseInput"
                  }`}
                />
              </Col>
            </Row>
            <Row align={"middle"} style={{ margin: "3rem 0" }}>
              <Col span={8}>
                <LabelInput text={"Liên kết"} />
              </Col>
              <Col span={16}>
                <InputText
                  typeInput={`${
                    !datapost.url && error.isError
                      ? "checkEmptyText baseInput"
                      : "baseInput"
                  }`}
                  text={datapost.url}
                  setText={(value) => setDataPost({ ...datapost, url: value })}
                  placeholder={"Nhập đường dẫn"}
                />
              </Col>
            </Row>
            <Row
              style={{ width: "100%" }}
              align={"middle"}
              justify={"space-between"}
            >
              <Col span={8}>
                <LabelInput text={"Thời gian bắt đầu"} />
              </Col>
              <Col span={16}>
                <DatePicker
                  // value={datapost?.timeStart}
                  format={"DD/MM/YYYY HH:mm:00"}
                  defaultValue={
                    datapost.timeStart
                      ? moment(datapost.timeStart, dateFormat)
                      : null
                  }
                  style={
                    (!datapost.timeStart ||
                      error.msg ===
                        "Thời gian bắt đầu phải nhỏ hơn Thời gian kết thúc") &&
                    error.isError
                      ? { border: "1px solid red", width: "100%" }
                      : { width: "100%" }
                  }
                  showTime
                  onChange={(value, date) => {
                    setDataPost({
                      ...datapost,
                      timeStart: value.format("YYYY-MM-DD HH:mm:ss"),
                    });
                  }}
                  placeholder={t("Chọn thời gian")}
                />
              </Col>
            </Row>
            <Row
              style={{ width: "100%", margin: "3rem 0" }}
              align={"middle"}
              justify={"space-between"}
            >
              <Col span={8}>
                <LabelInput text={"Thời gian kết thúc"} />
              </Col>
              <Col span={16}>
                <DatePicker
                  format={"DD/MM/YYYY HH:mm:59"}
                  // value={datapost.timeEnd}
                  placeholder={t("Chọn thời gian")}
                  defaultValue={
                    datapost.timeEnd
                      ? moment(datapost.timeEnd, dateFormat)
                      : null
                  }
                  style={
                    (!datapost.timeEnd ||
                      error.msg ===
                        "Thời gian bắt đầu phải nhỏ hơn Thời gian kết thúc") &&
                    error.isError
                      ? { border: "1px solid red", width: "100%" }
                      : { width: "100%" }
                  }
                  showTime
                  onChange={(value, date) => {
                    setDataPost({
                      ...datapost,
                      timeEnd: value.format("YYYY-MM-DD HH:mm:ss"),
                    });
                  }}
                />
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row style={{ width: "100%" }}>
              <Col span={12}>
                <LabelInput text={"Ảnh banner"} />
              </Col>
              <Col span={12}>
                <UpImageEdit
                  serverBanner={true}
                  url={valueEdit.imageBanner}
                  widthImage={162}
                  heightImage={738}
                  setImage={setImage}
                  width={"10.5rem"}
                  className={"chooseBanner"}
                  height={"450px"}
                  accept={".png, .jpg, .jpeg, .gif"}
                  image={image}
                  setFile={(value) =>
                    setDataPost({ ...datapost, fileImage: value })
                  }
                  style={
                    (!image && error.isError) ||
                    error.msg === "File có định dạng .jpeg, .png, .gif" ||
                    error.msg === "Dung lượng ảnh phải nhỏ hơn < 2MB" ||
                    error.msg === "Kích thước ảnh không hợp lệ"
                      ? { border: "1px solid red" }
                      : null
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>

        {error.isError ? (
          <small className="msgError errorBanner">{t(error.msg)}</small>
        ) : null}
      </Modal>
    </>
  );
};

export default ModalEditBanner;
